import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function Products() {
  return (
    <div className="page-wrapper" style={{ paddingTop: '120px' }}>
      <SEOHead
        title="Our Software Ecosystem"
        description="Redcubical Systems products: HealHub clinic management, Suraksha anti-fraud protection, Vedant AI health assistant, and HealHub Nexus professional network."
        canonical="/products"
      />

      {/* Hero Section */}
      <section style={{ padding: '80px 32px 120px' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
          <span className="section-label">Our Software Ecosystem</span>
          <h1 className="display-heading-md" style={{ marginBottom: '24px' }}>
            INTELLIGENT SYSTEMS<br />
            <span className="gradient-text">FOR MODERN CHALLENGES</span>
          </h1>
          <p className="section-subtitle" style={{ margin: '0 auto', fontSize: '18px' }}>
            We don't just build apps. We build ecosystems that simplify complexity, 
            automate operational hurdles, and empower professionals.
          </p>
        </div>
      </section>

      {/* Product Showcase */}
      <section style={{ padding: '0 32px 120px' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '120px' }}>
          
          {/* HealHub */}
          <div className="product-showcase-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }}>
            <div>
              <span className="badge" style={{ marginBottom: '16px', background: 'rgba(34,197,94,0.1)', borderColor: 'rgba(34,197,94,0.3)', color: '#22C55E' }}>LIVE PRODUCT</span>
              <h2 className="section-title" style={{ marginBottom: '24px' }}>HealHub:<br />Clinic Management</h2>
              <p className="body-text" style={{ marginBottom: '24px' }}>
                The backbone of modern healthcare providers. An end-to-end management platform handling 
                patient records, digital prescriptions, billing, and appointments. Built to eliminate 
                paperwork and focus on patient care.
              </p>
              <Link to="/healhub" className="btn-blue">Explore HealHub →</Link>
            </div>
            <div className="card" style={{ padding: '48px' }}>
              <div style={{ fontSize: '64px', marginBottom: '24px' }}>🏥</div>
              <h3 style={{ fontSize: '24px', marginBottom: '12px' }}>Operational Excellence</h3>
              <p className="body-text">Automate the boring parts of running a clinic. From check-ins to automated follow-ups, HealHub streamlines the entire patient journey.</p>
            </div>
          </div>

          {/* Suraksha */}
          <div className="product-showcase-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center', direction: 'rtl' }}>
             <div style={{ direction: 'ltr' }}>
              <span className="badge" style={{ marginBottom: '16px', background: 'rgba(245,158,11,0.1)', borderColor: 'rgba(245,158,11,0.3)', color: '#F59E0B' }}>COMING SOON</span>
              <h2 className="section-title" style={{ marginBottom: '24px' }}>Suraksha:<br />AI Anti-Fraud</h2>
              <p className="body-text" style={{ marginBottom: '24px' }}>
                India's most advanced cyber-security shield. Protect your family and finances with real-time 
                scam detection, AI-voice clone analysis, and emergency verification protocols.
              </p>
              <Link to="/suraksha" className="btn-primary">Learn More →</Link>
            </div>
            <div className="card" style={{ padding: '48px', direction: 'ltr' }}>
              <div style={{ fontSize: '64px', marginBottom: '24px' }}>🛡️</div>
              <h3 style={{ fontSize: '24px', marginBottom: '12px' }}>5-Layer Defense</h3>
              <p className="body-text">Beyond basic call blocking. Our AI analyzes voice patterns for AI-cloning, behavioural urgency cues, and real-time verification.</p>
            </div>
          </div>

          {/* Vedant */}
          <div className="product-showcase-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center' }}>
            <div>
              <span className="badge" style={{ marginBottom: '16px', background: 'rgba(168,85,247,0.1)', borderColor: 'rgba(168,85,247,0.3)', color: '#A855F7' }}>IN DEVELOPMENT</span>
              <h2 className="section-title" style={{ marginBottom: '24px' }}>Vedant:<br />AI Health Presence</h2>
              <p className="body-text" style={{ marginBottom: '24px' }}>
                The world’s first life-size AI Receptionist. "Google with a face" that greets patients, 
                manages check-ins, performs multilingual triage, and handles administrative tasks with 
                human-like presence.
              </p>
              <Link to="/vedant" className="btn-blue">See the Future →</Link>
            </div>
            <div className="card" style={{ padding: '48px' }}>
              <div style={{ fontSize: '64px', marginBottom: '24px' }}>🤖</div>
              <h3 style={{ fontSize: '24px', marginBottom: '12px' }}>75% Operational Savings</h3>
              <p className="body-text">Vedant replaces traditional front-desk overhead. Available 24/7, bilingual, and perfectly synced with your HealHub dashboard.</p>
            </div>
          </div>

          {/* HealHub Nexus */}
          <div className="product-showcase-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '80px', alignItems: 'center', direction: 'rtl' }}>
             <div style={{ direction: 'ltr' }}>
              <span className="badge" style={{ marginBottom: '16px', background: 'rgba(59,130,246,0.1)', borderColor: 'rgba(59,130,246,0.3)', color: '#3B82F6' }}>LIVE NETWORK</span>
              <h2 className="section-title" style={{ marginBottom: '24px' }}>HealHub Nexus:<br />Doctor Network</h2>
              <p className="body-text" style={{ marginBottom: '24px' }}>
                The "LinkedIn for Doctors." A verified, structured professional network. Connect with 
                specialists, manage visiting consultants, and facilitate structured patient referrals 
                within a trusted ecosystem.
              </p>
              <Link to="/healhub" className="btn-primary">Join the Network →</Link>
            </div>
            <div className="card" style={{ padding: '48px', direction: 'ltr' }}>
              <div style={{ fontSize: '64px', marginBottom: '24px' }}>🌐</div>
              <h3 style={{ fontSize: '24px', marginBottom: '12px' }}>Structured Collaboration</h3>
              <p className="body-text">No spam, no noise. Just verified medical professionals, structured case study discussions, and professional opportunity management.</p>
            </div>
          </div>

        </div>
      </section>

      {/* CTA Section */}
      <section style={{ padding: '80px 32px', background: 'var(--dark-2)' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h2 className="section-title" style={{ marginBottom: '20px' }}>Ready to transform your operations?</h2>
          <p className="section-subtitle" style={{ margin: '0 auto 32px' }}>
            Whether you are a clinic, a business, or a partner, let’s discuss how our software suite can solve your challenges.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
             <Link to="/contact" className="btn-blue">Start a Conversation →</Link>
             <Link to="/services" className="btn-outline">View Custom Services</Link>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 900px) {
          .product-showcase-grid { grid-template-columns: 1fr !important; direction: ltr !important; }
        }
      `}</style>
    </div>
  );
}